import { useCallback, useEffect, useState } from "react";
import { listPages } from "../../../api/pagesApi";
import { listSections } from "../../../api/sectionsApi";
import { getApiErrorMessage } from "../../../api/unwrapApiResponse";

const WORK_SLUG = "work";
const PROJECTS_SECTION_KEY = "work-projects";

export function useProjectsSection() {
  const [sectionId, setSectionId] = useState(null);
  const [pageId, setPageId] = useState(null);
  const [pageName, setPageName] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const resolve = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const pages = await listPages();
      const list = Array.isArray(pages) ? pages : [];
      const workPage =
        list.find((p) => (p.slug || "").toLowerCase() === WORK_SLUG) ||
        list.find((p) => (p.name || "").toLowerCase() === "work");

      if (!workPage) {
        setError('No Work page found. Create a page with slug "work" first.');
        setSectionId(null);
        return;
      }

      const sections = await listSections(workPage.id);
      const sectionList = Array.isArray(sections) ? sections : [];
      const projectsSection =
        sectionList.find(
          (s) => (s.sectionType || "").toLowerCase() === "projects"
        ) ||
        sectionList.find(
          (s) => (s.key || "").toLowerCase() === PROJECTS_SECTION_KEY
        );

      if (!projectsSection) {
        setError(
          'No work projects section found. Add a section with type "projects" and key "work-projects".'
        );
        setPageId(workPage.id);
        setPageName(workPage.name || "Work");
        setSectionId(null);
        return;
      }

      setPageId(workPage.id);
      setPageName(workPage.name || "Work");
      setSectionId(projectsSection.id);
      setSectionName(projectsSection.name || "Work Projects");
    } catch (err) {
      setError(getApiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    resolve();
  }, [resolve]);

  return {
    sectionId,
    pageId,
    pageName,
    sectionName,
    loading,
    error,
    reload: resolve,
  };
}
